import authInstance from 'config/axios.config';

export const adminServices = {
  getAdmins: async ({ page, limit, status, role, search, sortBy, sortOrder, twoFactorAuth }) => {
    const params = new URLSearchParams({
      page: page?.toString() || '1',
      limit: limit?.toString() || '10',
      status: status === 'all' ? '' : status || '',
      role: role === 'all' ? '' : role || '',
      search: search || '',
      sortBy: sortBy || 'createdAt',
      sortOrder: sortOrder || 'desc',
      twoFactorAuth: twoFactorAuth === 'all' ? '' : twoFactorAuth || '',
    });

    // Remove empty params
    for (const [key, value] of [...params.entries()]) {
      if (!value) params.delete(key);
    }

    const res = await authInstance.get(`/admin?${params}`);
    return res.data;
  },

  getAdminById: async (adminId) => {
    const res = await authInstance.get(`/admin/auth/admins/${adminId}`);
    return res.data;
  },

  addAdmin: async (adminData) => {
    const res = await authInstance.post('/admin', adminData);
    return res.data;
  },

  updateAdmin: async ({ userId, userdata }) => {
    const res = await authInstance.patch(`/admin/${userId}`, userdata);
    return res.data;
  },

  deleteAdmin: async (adminId) => {
    const res = await authInstance.delete(`/admin/${adminId}`);
    return res.data;
  },

  toggleAdminStatus: async (adminId) => {
    const res = await authInstance.patch(`/admin/auth/admins/${adminId}/toggle-status`);
    return res.data;
  },

  getRoles: async () => {
    const res = await authInstance.get('/admin/auth/roles');
    return res.data;
  },

  exportAdmins: async ({
  status,
  role,
  search,
  sortBy,
  sortOrder,
  twoFactorAuth,
}) => {
  const params = new URLSearchParams({
    status: status === 'all' ? '' : status || '',
    role: role === 'all' ? '' : role || '',
    search: search || '',
    sortBy: sortBy || 'createdAt',
    sortOrder: sortOrder || 'desc',
    twoFactorAuth:
      twoFactorAuth === 'all'
        ? ''
        : twoFactorAuth || '',
  });

  // Remove empty params
  for (const [key, value] of [...params.entries()]) {
    if (!value) params.delete(key);
  }

  return authInstance.get(
    `/admin/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
